export default[
    {
        path: '/irrf/cadastro',
        name: 'cadastro do irrf', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/irrf/lista',
        name: 'lista do irrf', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/irrf/editar/:id',
        name: 'editar o irrf', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]